import { ModelBase, Property, Required, ShortString, VeryShortString } from '@skylab-shared/core';

export class BankAccountModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    public default: boolean;

    @Property()
    @ShortString('data-model.bank-account.validation.name.length')
    @Required('data-model.bank-account.validation.name.non-empty')
    public name: string;

    @Property()
    @ShortString('data-model.bank-account.validation.bank-name.length')
    @Required('data-model.bank-account.validation.bank-name.non-empty')
    public bankName: string;

    @Property()
    @VeryShortString('data-model.bank-account.validation.swift.length')
    public swift: string;

    @Property()
    @ShortString('data-model.bank-account.validation.account-number.length')
    @Required('data-model.bank-account.validation.account-number.non-empty')
    public number: string;

    @Property()
    public currencyId: number;
}
